import React, { useState, useEffect } from "react";
import {
  IconSearch,
  IconPlus,
  IconChevronLeft,
  IconChevronRight,
  IconX,
  IconEye,
  IconEdit,
  IconTrash,
  IconUpload,
  IconDownload,
  IconDotsVertical,
  IconCalendar,
  IconFilter,
  IconRefresh,
  IconChevronDown,
} from "@tabler/icons-react";
import ListView from "../../../components/common/ListView";
import { 
  fetchHrEmployees, 
  fetchHrDesignations,
  fetchHrAppraisals,
  createHrAppraisal,
  updateHrAppraisal,
  deleteHrAppraisal,
  fetchHrCompany,
  fetchHrBranches,
  fetchHrRelegations,
  createHrRelegation,
  updateHrRelegation,
  deleteHrRelegation,
  fetchHrRewards,
  createHrReward,
  updateHrReward,
  deleteHrReward
} from "../../../apis/hrApi";
import toast from "react-hot-toast";

const SectionBlock = ({
  title,
  icon: Icon,
  children,
}: {
  title: string;
  icon: any;
  children: React.ReactNode;
}) => (
  <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-slate-200/50 shadow-sm p-4 transition-all duration-300 space-y-4 relative">
    <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/10 to-transparent pointer-events-none" />
    <div className="flex items-center gap-2 border-[#FBD037]/30 pb-2 mb-1.5 relative z-10 border-b">
      <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
        <Icon size={16} className="text-[#212121]" stroke={1.5} />
      </div>
      <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
        {title}
      </p>
    </div>
    <div className="relative z-10 space-y-4">
      {children}
    </div>
  </div>
);

export default function Action() {
  const [actionSubTab, setActionSubTab] = useState("Appraisal");
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  
  // Row menus toggles
  const [openRowMenuId, setOpenRowMenuId] = useState<any | null>(null);

  // Dynamic Employees dropdown mapping list
  const [employees, setEmployees] = useState<any[]>([]);
  const [designations, setDesignations] = useState<any[]>([]);

  // Appraisal states list
  const [appraisalList, setAppraisalList] = useState<any[]>([]);
  const [selectedAppraisal, setSelectedAppraisal] = useState<any | null>(null);

  // Appraisal Sidebar state variables
  const [isAppraisalPanelOpen, setIsAppraisalPanelOpen] = useState(false);
  const [appraisalPanelType, setAppraisalPanelType] = useState<"add" | "edit" | "view" | "import" | "filter">("add");

  // Relegation states list
  const [relegationList, setRelegationList] = useState<any[]>([]);
  const [selectedRelegation, setSelectedRelegation] = useState<any | null>(null);
  
  // Relegation Sidebar state variables
  const [isRelegationPanelOpen, setIsRelegationPanelOpen] = useState(false);
  const [relegationPanelType, setRelegationPanelType] = useState<"add" | "edit" | "view" | "import" | "filter">("add");

  // Metadata ids from backend
  const [companyId, setCompanyId] = useState("");
  const [branchId, setBranchId] = useState("");

  // Appraisal Form states (Add & Edit)
  const [formEmployeeId, setFormEmployeeId] = useState("");
  const [formOldDesignation, setFormOldDesignation] = useState("");
  const [formOldDesignationId, setFormOldDesignationId] = useState("");
  const [formNewDesignation, setFormNewDesignation] = useState("");
  const [formEffectiveDate, setFormEffectiveDate] = useState("");
  const [formOldCtc, setFormOldCtc] = useState("");
  const [formNewCtc, setFormNewCtc] = useState("");
  const [formRemarks, setFormRemarks] = useState("");

  // Relegation Form states (Add & Edit)
  const [relegationEmployeeId, setRelegationEmployeeId] = useState("");
  const [relegationOldDesignation, setRelegationOldDesignation] = useState("");
  const [relegationOldDesignationId, setRelegationOldDesignationId] = useState("");
  const [relegationNewDesignation, setRelegationNewDesignation] = useState("");
  const [relegationEffectiveDate, setRelegationEffectiveDate] = useState("");
  const [relegationOldCtc, setRelegationOldCtc] = useState("");
  const [relegationNewCtc, setRelegationNewCtc] = useState("");
  const [relegationRemarks, setRelegationRemarks] = useState("");

  // Appraisal Filters State
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [filterEmployee, setFilterEmployee] = useState("");
  const [filterAppraisalBy, setFilterAppraisalBy] = useState("");

  // Relegation Filters State
  const [filterRelegationStartDate, setFilterRelegationStartDate] = useState("");
  const [filterRelegationEndDate, setFilterRelegationEndDate] = useState("");
  const [filterRelegationEmployee, setFilterRelegationEmployee] = useState("");
  const [filterRelegationBy, setFilterRelegationBy] = useState("");

  // Rewards states list
  const [rewardList, setRewardList] = useState<any[]>([]);
  const [selectedReward, setSelectedReward] = useState<any | null>(null);

  // Rewards Sidebar state variables
  const [isRewardPanelOpen, setIsRewardPanelOpen] = useState(false);
  const [rewardPanelType, setRewardPanelType] = useState<"add" | "edit" | "view" | "import" | "filter">("add");

  // Rewards Form states
  const [rewardEmployeeId, setRewardEmployeeId] = useState("");
  const [rewardDate, setRewardDate] = useState("");
  const [rewardType, setRewardType] = useState("NonMonetary");
  const [rewardLinkAppreciation, setRewardLinkAppreciation] = useState(false);
  const [rewardReason, setRewardReason] = useState("");

  // Rewards Filters State
  const [filterRewardStartDate, setFilterRewardStartDate] = useState("");
  const [filterRewardEndDate, setFilterRewardEndDate] = useState("");
  const [filterRewardEmployeeId, setFilterRewardEmployeeId] = useState("");
  const [filterRewardRewardedById, setFilterRewardRewardedById] = useState("");
  const [filterRewardType, setFilterRewardType] = useState("");

  // Status dropdown toggle menu anchor row ID
  const [openStatusMenuId, setOpenStatusMenuId] = useState<any | null>(null);

  // Fetch HR metadata on mount
  useEffect(() => {
    const loadMetadata = async () => {
      try {
        const empRes = await fetchHrEmployees();
        if (empRes.success && empRes.data?.employees) {
          const mappedEmp = empRes.data.employees.map((emp: any) => ({
            id: emp.id || emp._id,
            name: emp.firstName ? `${emp.firstName} ${emp.lastName || ""}` : emp.name || "Unknown",
            dept: emp.departmentName || emp.department || "Demo",
            designation: emp.designationName || emp.designation || "Demo",
            designationId: emp.designationId || emp.designation?._id || "",
            email: emp.workEmail || emp.personalEmail || emp.email || "demo@gmail.com",
            ctc: emp.salary || emp.ctc || 10000
          }));
          setEmployees(mappedEmp);
        }

        const desRes = await fetchHrDesignations();
        if (desRes.success && desRes.data?.designations) {
          const mappedDes = desRes.data.designations.map((d: any) => ({
            id: d.id || d._id || d.designationId,
            name: d.designationName || "Demo"
          }));
          setDesignations(mappedDes);
        }

        const compRes = await fetchHrCompany();
        if (compRes.success && compRes.data) {
          setCompanyId(compRes.data.id || compRes.data._id || "");
        }

        const branchRes = await fetchHrBranches(1, 10);
        if (branchRes.success && branchRes.data?.branches?.length > 0) {
          setBranchId(branchRes.data.branches[0].id || branchRes.data.branches[0]._id || "");
        }
      } catch (err) {
        console.error(err);
      }
    };
    loadMetadata();
  }, []);

  // Fetch live appraisals list from backend API
  const loadAppraisals = async () => {
    setIsLoading(true);
    try {
      const res = await fetchHrAppraisals();
      if (res.success && res.data) {
        const apiList = res.data.appraisals || res.data.data || res.data || [];
        if (Array.isArray(apiList)) {
          if (apiList.length === 0) {
            setAppraisalList([]);
            return;
          }
          
          const mapped = apiList.map((item: any) => {
            const empName = item.employee
              ? `${item.employee.firstName || ""} ${item.employee.lastName || ""}`.trim()
              : item.employeeName || "Unknown";
              
            const empDept = item.employee?.departmentName || item.employee?.department?.departmentName || "Demo";
            
            const oldDes = item.oldDesignation?.designationName || item.oldDesignationName || "Demo";
            const newDes = item.newDesignation?.designationName || item.newDesignationName || "Demo";
            
            const appBy = item.appraisalByName || (item.processedBy
              ? `${item.processedBy.firstName || ""} ${item.processedBy.lastName || ""}`.trim()
              : item.processedByName || "Sandeep Patel");
              
            const appByDept = item.processedBy?.designationName || item.processedByDept || "Software Engineer";

            const cDate = item.createdAt ? new Date(item.createdAt) : new Date();
            const formattedCreatedDate = cDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedCreatedTime = cDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            const uDate = item.updatedAt ? new Date(item.updatedAt) : new Date();
            const formattedUpdatedDate = uDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedUpdatedTime = uDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            const mapStatus = (st: string) => {
              if (!st) return "Pending";
              const lower = st.toLowerCase();
              if (lower === "active") return "Approved";
              return lower.charAt(0).toUpperCase() + lower.slice(1);
            };

            return {
              id: item.id || item._id,
              name: empName,
              dept: empDept,
              designation: item.employee?.designationName || "Demo",
              oldDesignation: oldDes,
              newDesignation: newDes,
              effectiveDate: item.effectiveDate ? item.effectiveDate.split("T")[0] : "",
              appraisalDate: item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-GB").replace(/\//g, "-") : formattedCreatedDate,
              appraisalBy: appBy,
              appraisalByDept: appByDept,
              appraisalByEmail: item.processedBy?.workEmail || item.processedBy?.email || "sandeep.ywppl@gmail.com",
              status: mapStatus(item.status),
              createdDate: formattedCreatedDate,
              createdTime: formattedCreatedTime,
              updatedDate: formattedUpdatedDate,
              updatedTime: formattedUpdatedTime,
              oldCtc: Number(item.oldCtc || 0),
              newCtc: Number(item.newCtc || 0),
              incrementAmount: Number(item.newCtc || 0) - Number(item.oldCtc || 0),
              incrementPercent: Number(item.oldCtc || 0) > 0 ? Number((((Number(item.newCtc) - Number(item.oldCtc)) / Number(item.oldCtc)) * 100).toFixed(2)) : 0,
              remarks: item.remarks || "",
              raw: item
            };
          });
          setAppraisalList(mapped);
        }
      }
    } catch (err) {
      console.error("Failed to load appraisals:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch live relegations list from backend API
  const loadRelegations = async () => {
    setIsLoading(true);
    try {
      const res = await fetchHrRelegations();
      if (res.success && res.data) {
        const apiList = res.data.relegations || res.data.data || res.data || [];
        if (Array.isArray(apiList)) {
          if (apiList.length === 0) {
            setRelegationList([]);
            return;
          }
          
          const mapped = apiList.map((item: any) => {
            const empName = item.employee
              ? `${item.employee.firstName || ""} ${item.employee.lastName || ""}`.trim()
              : item.employeeName || "Unknown";
              
            const empDept = item.employee?.departmentName || item.employee?.department?.departmentName || "Demo";
            
            const oldDes = item.oldDesignation?.designationName || item.oldDesignationName || "Demo";
            const newDes = item.newDesignation?.designationName || item.newDesignationName || "Demo";
            
            const appBy = item.relegationByName || (item.processedBy
              ? `${item.processedBy.firstName || ""} ${item.processedBy.lastName || ""}`.trim()
              : item.processedByName || "Sandeep Patel");
              
            const appByDept = item.processedBy?.designationName || item.processedByDept || "Software Engineer";

            const cDate = item.createdAt ? new Date(item.createdAt) : new Date();
            const formattedCreatedDate = cDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedCreatedTime = cDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            const uDate = item.updatedAt ? new Date(item.updatedAt) : new Date();
            const formattedUpdatedDate = uDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedUpdatedTime = uDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            return {
              id: item.id || item._id,
              name: empName,
              dept: empDept,
              designation: item.employee?.designationName || "Demo",
              oldDesignation: oldDes,
              newDesignation: newDes,
              effectiveDate: item.effectiveDate ? item.effectiveDate.split("T")[0] : "",
              relegationDate: item.createdAt ? new Date(item.createdAt).toLocaleDateString("en-GB").replace(/\//g, "-") : formattedCreatedDate,
              relegatedBy: appBy,
              relegatedByDept: appByDept,
              relegatedByEmail: item.processedBy?.workEmail || item.processedBy?.email || "sandeep.ywppl@gmail.com",
              status: item.status || "Active",
              createdDate: formattedCreatedDate,
              createdTime: formattedCreatedTime,
              updatedDate: formattedUpdatedDate,
              updatedTime: formattedUpdatedTime,
              oldCtc: Number(item.oldCtc || 0),
              newCtc: Number(item.newCtc || 0),
              decrementAmount: Number(item.oldCtc || 0) - Number(item.newCtc || 0),
              decrementPercent: Number(item.oldCtc || 0) > 0 ? Number((((Number(item.oldCtc) - Number(item.newCtc)) / Number(item.oldCtc)) * 100).toFixed(2)) : 0,
              remarks: item.remarks || "",
              raw: item
            };
          });
          setRelegationList(mapped);
        }
      }
    } catch (err) {
      console.error("Failed to load relegations:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch live rewards list from backend API
  const loadRewards = async () => {
    setIsLoading(true);
    try {
      const res = await fetchHrRewards();
      if (res.success && res.data) {
        const apiList = res.data.rewards || res.data.data || res.data || [];
        if (Array.isArray(apiList)) {
          if (apiList.length === 0) {
            setRewardList([]);
            return;
          }
          
          const mapped = apiList.map((item: any) => {
            const empName = item.employee
              ? `${item.employee.firstName || ""} ${item.employee.lastName || ""}`.trim()
              : item.employeeName || "Unknown";
              
            const empDept = item.employee?.departmentName || item.employee?.department?.departmentName || "Demo";
            
            const processedBy = item.processedBy
              ? `${item.processedBy.firstName || ""} ${item.processedBy.lastName || ""}`.trim()
              : item.processedByName || "Daksh";
              
            const processedByDept = item.processedBy?.designationName || item.processedByDept || "Human Resources";

            const approvedBy = item.approvedBy
              ? `${item.approvedBy.firstName || ""} ${item.approvedBy.lastName || ""}`.trim()
              : item.approvedByName || "-";
            
            const approvedByDept = item.approvedBy?.designationName || item.approvedByDept || "";

            const cDate = item.createdAt ? new Date(item.createdAt) : new Date();
            const formattedCreatedDate = cDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedCreatedTime = cDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            const uDate = item.updatedAt ? new Date(item.updatedAt) : new Date();
            const formattedUpdatedDate = uDate.toLocaleDateString("en-GB").replace(/\//g, "-");
            const formattedUpdatedTime = uDate.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

            const rewardD = item.rewardDate ? new Date(item.rewardDate) : new Date();
            const formattedRewardDate = rewardD.toLocaleDateString("en-GB").replace(/\//g, "-");

            return {
              id: item.id || item._id,
              employeeId: item.employeeId || item.employee?.id || "",
              name: empName,
              dept: empDept,
              designation: item.employee?.designationName || "Demo",
              employeeIdStr: item.employee?.employeeIdStr || item.employee?.employeeId || `EMP#${String(item.id || "").substring(0, 4)}`,
              rewardRemark: item.reason || item.remarks || "",
              rewardDate: formattedRewardDate,
              rewardRawDate: item.rewardDate ? item.rewardDate.split("T")[0] : "",
              rewardedBy: processedBy,
              rewardedByDept: processedByDept,
              status: item.status || "Pending",
              approvedBy: approvedBy,
              approvedByDept: approvedByDept,
              linkAppreciation: item.linkAppreciation || false,
              rewardType: item.rewardType || "NonMonetary",
              createdDate: formattedCreatedDate,
              createdTime: formattedCreatedTime,
              updatedDate: formattedUpdatedDate,
              updatedTime: formattedUpdatedTime,
              raw: item
            };
          });
          setRewardList(mapped);
        }
      }
    } catch (err) {
      console.error("Failed to load rewards:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddRewardSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!rewardEmployeeId) {
      toast.error("Please select an employee");
      return;
    }
    
    const currentUserId = "11111111-1111-1111-1111-111111111111";
    const payload = {
      companyId: companyId || "11111111-1111-1111-1111-111111111111",
      branchId: branchId || "22222222-2222-2222-2222-222222222222",
      employeeId: rewardEmployeeId,
      rewardDate: rewardDate || new Date().toISOString().split("T")[0],
      rewardType: rewardType,
      linkAppreciation: rewardLinkAppreciation,
      reason: rewardReason,
      processedById: currentUserId,
      status: "PENDING"
    };

    const loader = toast.loading("Adding reward request...");
    try {
      const res = await createHrReward(payload);
      if (res.success) {
        toast.success("Reward request added successfully", { id: loader });
        setIsRewardPanelOpen(false);
        loadRewards();
      } else {
        toast.error(res.message || "Failed to add reward", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to add reward", { id: loader });
    }
  };

  const handleEditRewardSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedReward) return;

    const payload = {
      employeeId: rewardEmployeeId,
      rewardDate: rewardDate || new Date().toISOString().split("T")[0],
      rewardType: rewardType,
      linkAppreciation: rewardLinkAppreciation,
      reason: rewardReason
    };

    const loader = toast.loading("Updating reward details...");
    try {
      const res = await updateHrReward(selectedReward.id, payload);
      if (res.success) {
        toast.success("Reward details updated successfully", { id: loader });
        setIsRewardPanelOpen(false);
        loadRewards();
      } else {
        toast.error(res.message || "Failed to update reward", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to update reward", { id: loader });
    }
  };

  const handleStatusChange = async (id: string, newStatus: string) => {
    const loader = toast.loading(`Updating status to ${newStatus}...`);
    try {
      const currentUserId = "11111111-1111-1111-1111-111111111111";
      const payload = {
        status: newStatus.toUpperCase(),
        approvedById: newStatus === "Approved" ? currentUserId : null
      };

      const res = await updateHrReward(id, payload);
      if (res.success) {
        toast.success(`Reward status updated to ${newStatus}`, { id: loader });
        loadRewards();
      } else {
        toast.error(res.message || "Failed to update status", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to update status", { id: loader });
    }
  };

  const handleDeleteReward = async (id: string) => {
    if (!window.confirm("Are you sure you want to delete this reward request?")) return;
    const loader = toast.loading("Deleting reward...");
    try {
      const res = await deleteHrReward(id);
      if (res.success) {
        toast.success("Reward request deleted", { id: loader });
        loadRewards();
      } else {
        toast.error(res.message || "Failed to delete reward", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to delete reward", { id: loader });
    }
  };

  const handleOpenRewardEdit = (record: any) => {
    setSelectedReward(record);
    setRewardEmployeeId(record.employeeId || "");
    setRewardDate(record.rewardRawDate || "");
    setRewardType(record.rewardType || "NonMonetary");
    setRewardLinkAppreciation(record.linkAppreciation || false);
    setRewardReason(record.rewardRemark || "");
    setRewardPanelType("edit");
    setIsRewardPanelOpen(true);
  };

  // Load backend records on component mount
  useEffect(() => {
    loadAppraisals();
    loadRelegations();
    loadRewards();
  }, []);

  // Update Old Designation and Old CTC automatically when an employee is chosen for Appraisal
  useEffect(() => {
    if (formEmployeeId) {
      const emp = employees.find(e => e.id === formEmployeeId);
      if (emp) {
        setFormOldDesignation(emp.designation);
        setFormOldDesignationId(emp.designationId);
        setFormOldCtc(String(emp.ctc || "5000"));
        if (!formNewCtc) setFormNewCtc(String(Number(emp.ctc || 5000) + 5000));
      }
    }
  }, [formEmployeeId, employees]);

  // Update Old Designation and Old CTC automatically when an employee is chosen for Relegation
  useEffect(() => {
    if (relegationEmployeeId) {
      const emp = employees.find(e => e.id === relegationEmployeeId);
      if (emp) {
        setRelegationOldDesignation(emp.designation);
        setRelegationOldDesignationId(emp.designationId);
        setRelegationOldCtc(String(emp.ctc || "10000"));
        if (!relegationNewCtc) setRelegationNewCtc(String(Number(emp.ctc || 10000) - 2000));
      }
    }
  }, [relegationEmployeeId, employees]);

  // Derived Calculations for Appraisal
  const calculatedIncrement = Number(formNewCtc || 0) - Number(formOldCtc || 0);
  const calculatedPercent = Number(formOldCtc || 0) > 0 
    ? ((calculatedIncrement / Number(formOldCtc)) * 100).toFixed(2)
    : "0.00";

  // Derived Calculations for Relegation
  const calculatedDecrement = Number(relegationOldCtc || 0) - Number(relegationNewCtc || 0);
  const calculatedDecrementPercent = Number(relegationOldCtc || 0) > 0 
    ? ((calculatedDecrement / Number(relegationOldCtc)) * 100).toFixed(2)
    : "0.00";

  // Handle Add Appraisal Submit
  const handleAddSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formEmployeeId || !formNewDesignation || !formEffectiveDate || !formRemarks) {
      toast.error("Please fill all required fields");
      return;
    }

    let appraiserId = "";
    const possibleAppraisers = ["Sandeep Patel", "Yash Koladiya", "Sneha Joshi"];
    for (const name of possibleAppraisers) {
      const found = employees.find(e => e.name.toLowerCase().includes(name.toLowerCase()));
      if (found) {
        appraiserId = found.id;
        break;
      }
    }
    if (!appraiserId && employees.length > 0) {
      appraiserId = employees[0].id;
    }
    const currentUserId = window.localStorage.getItem("employeeId") || window.localStorage.getItem("userId") || appraiserId || "8b2c7d55-89d0-4af7-a2aa-8f8f10e4d444";

    const payload = {
      employeeId: formEmployeeId,
      oldDesignationId: formOldDesignationId || null,
      newDesignationId: formNewDesignation,
      effectiveDate: formEffectiveDate,
      oldCtc: String(formOldCtc || "0"),
      newCtc: String(formNewCtc || "0"),
      incrementAmount: String(calculatedIncrement),
      incrementPercentage: String(calculatedPercent),
      remarks: formRemarks,
      status: "ACTIVE"
    };

    const loader = toast.loading("Creating appraisal request...");
    try {
      const res = await createHrAppraisal(payload);
      if (res.success) {
        toast.success("Appraisal request created successfully", { id: loader });
        setIsAppraisalPanelOpen(false);
        // Clear Form
        setFormEmployeeId("");
        setFormOldDesignation("");
        setFormOldDesignationId("");
        setFormNewDesignation("");
        setFormEffectiveDate("");
        setFormOldCtc("");
        setFormNewCtc("");
        setFormRemarks("");
        loadAppraisals();
      } else {
        toast.error(res.message || "Failed to create appraisal", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to create appraisal", { id: loader });
    }
  };

  // Open Edit Appraisal Form in Sidebar Panel
  const handleOpenEdit = (record: any) => {
    setSelectedAppraisal(record);
    const emp = employees.find(e => e.name === record.name);
    setFormEmployeeId(emp ? emp.id : "");
    setFormOldDesignation(record.oldDesignation);
    setFormOldDesignationId(record.raw?.oldDesignationId || "");
    
    // Find designation id or keep text name
    const des = designations.find(d => d.name === record.newDesignation);
    setFormNewDesignation(des ? des.id : record.newDesignation);
    
    setFormEffectiveDate(record.effectiveDate);
    setFormOldCtc(String(record.oldCtc));
    setFormNewCtc(String(record.newCtc));
    setFormRemarks(record.remarks);

    setAppraisalPanelType("edit");
    setIsAppraisalPanelOpen(true);
  };

  // Handle Edit Appraisal Submit
  const handleEditSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedAppraisal) return;

    let appraiserId = "";
    const possibleAppraisers = ["Sandeep Patel", "Yash Koladiya", "Sneha Joshi"];
    for (const name of possibleAppraisers) {
      const found = employees.find(e => e.name.toLowerCase().includes(name.toLowerCase()));
      if (found) {
        appraiserId = found.id;
        break;
      }
    }
    if (!appraiserId && employees.length > 0) {
      appraiserId = employees[0].id;
    }
    const currentUserId = window.localStorage.getItem("employeeId") || window.localStorage.getItem("userId") || appraiserId || "8b2c7d55-89d0-4af7-a2aa-8f8f10e4d444";

    const payload = {
      branchId: selectedAppraisal.raw?.branchId || branchId || "22222222-2222-2222-2222-222222222222",
      employeeId: formEmployeeId || selectedAppraisal.raw?.employeeId,
      oldDesignationId: formOldDesignationId || selectedAppraisal.raw?.oldDesignationId || null,
      newDesignationId: formNewDesignation,
      effectiveDate: formEffectiveDate,
      oldCtc: String(formOldCtc || "0"),
      newCtc: String(formNewCtc || "0"),
      incrementAmount: String(calculatedIncrement),
      incrementPercentage: String(calculatedPercent),
      remarks: formRemarks,
      status: selectedAppraisal.raw?.status || "ACTIVE"
    };

    const loader = toast.loading("Updating appraisal...");
    try {
      const res = await updateHrAppraisal(selectedAppraisal.id, payload);
      if (res.success) {
        toast.success("Appraisal updated successfully", { id: loader });
        setIsAppraisalPanelOpen(false);
        loadAppraisals();
      } else {
        toast.error(res.message || "Failed to update appraisal", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to update appraisal", { id: loader });
    }
  };

  // Open Edit Relegation form inside Sidebar Drawer
  const handleOpenRelegationEdit = (record: any) => {
    setSelectedRelegation(record);
    const emp = employees.find(e => e.name === record.name);
    setRelegationEmployeeId(emp ? emp.id : "");
    setRelegationOldDesignation(record.oldDesignation);
    setRelegationOldDesignationId(record.raw?.oldDesignationId || "");

    // Find designation id or keep text name
    const des = designations.find(d => d.name === record.newDesignation);
    setRelegationNewDesignation(des ? des.id : record.newDesignation);

    setRelegationEffectiveDate(record.effectiveDate);
    setRelegationOldCtc(String(record.oldCtc));
    setRelegationNewCtc(String(record.newCtc));
    setRelegationRemarks(record.remarks);

    setRelegationPanelType("edit");
    setIsRelegationPanelOpen(true);
  };

  // Handle Create Relegation Submit
  const handleAddRelegationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!relegationEmployeeId || !relegationNewDesignation || !relegationEffectiveDate || !relegationRemarks) {
      toast.error("Please fill all required fields");
      return;
    }

    let appraiserId = "";
    const possibleAppraisers = ["Sandeep Patel", "Yash Koladiya", "Sneha Joshi"];
    for (const name of possibleAppraisers) {
      const found = employees.find(e => e.name.toLowerCase().includes(name.toLowerCase()));
      if (found) {
        appraiserId = found.id;
        break;
      }
    }
    if (!appraiserId && employees.length > 0) {
      appraiserId = employees[0].id;
    }
    const currentUserId = window.localStorage.getItem("employeeId") || window.localStorage.getItem("userId") || appraiserId || "8b2c7d55-89d0-4af7-a2aa-8f8f10e4d444";

    const payload = {
      employeeId: relegationEmployeeId,
      oldDesignationId: relegationOldDesignationId || null,
      newDesignationId: relegationNewDesignation,
      effectiveDate: relegationEffectiveDate,
      oldCtc: Number(relegationOldCtc || 0),
      newCtc: Number(relegationNewCtc || 0),
      decrementAmount: Number(calculatedDecrement),
      decrementPercentage: Number(calculatedDecrementPercent),
      remarks: relegationRemarks,
      status: "ACTIVE"
    };

    const loader = toast.loading("Creating relegation request...");
    try {
      const res = await createHrRelegation(payload);
      if (res.success) {
        toast.success("Relegation request created successfully", { id: loader });
        setIsRelegationPanelOpen(false);
        // Clear Form
        setRelegationEmployeeId("");
        setRelegationOldDesignation("");
        setRelegationOldDesignationId("");
        setRelegationNewDesignation("");
        setRelegationEffectiveDate("");
        setRelegationOldCtc("");
        setRelegationNewCtc("");
        setRelegationRemarks("");
        loadRelegations();
      } else {
        toast.error(res.message || "Failed to create relegation", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to create relegation", { id: loader });
    }
  };

  // Handle Edit Relegation Submit
  const handleEditRelegationSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedRelegation) return;

    let appraiserId = "";
    const possibleAppraisers = ["Sandeep Patel", "Yash Koladiya", "Sneha Joshi"];
    for (const name of possibleAppraisers) {
      const found = employees.find(e => e.name.toLowerCase().includes(name.toLowerCase()));
      if (found) {
        appraiserId = found.id;
        break;
      }
    }
    if (!appraiserId && employees.length > 0) {
      appraiserId = employees[0].id;
    }
    const currentUserId = window.localStorage.getItem("employeeId") || window.localStorage.getItem("userId") || appraiserId || "8b2c7d55-89d0-4af7-a2aa-8f8f10e4d444";

    const payload = {
      branchId: selectedRelegation.raw?.branchId || branchId || "22222222-2222-2222-2222-222222222222",
      employeeId: relegationEmployeeId || selectedRelegation.raw?.employeeId,
      oldDesignationId: relegationOldDesignationId || selectedRelegation.raw?.oldDesignationId || null,
      newDesignationId: relegationNewDesignation,
      effectiveDate: relegationEffectiveDate,
      oldCtc: Number(relegationOldCtc || 0),
      newCtc: Number(relegationNewCtc || 0),
      decrementAmount: Number(calculatedDecrement),
      decrementPercentage: Number(calculatedDecrementPercent),
      remarks: relegationRemarks,
      status: selectedRelegation.raw?.status || "ACTIVE"
    };

    const loader = toast.loading("Updating relegation...");
    try {
      const res = await updateHrRelegation(selectedRelegation.id, payload);
      if (res.success) {
        toast.success("Relegation updated successfully", { id: loader });
        setIsRelegationPanelOpen(false);
        loadRelegations();
      } else {
        toast.error(res.message || "Failed to update relegation", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to update relegation", { id: loader });
    }
  };

  // Handle Delete Relegation
  const handleDeleteRelegation = async (id: any) => {
    if (typeof id === "number" || (typeof id === "string" && id.startsWith("r"))) {
      setRelegationList(relegationList.filter(item => item.id !== id));
      toast.success("Fallback relegation record deleted");
      return;
    }

    const loader = toast.loading("Deleting Relegation...");
    try {
      const res = await deleteHrRelegation(id);
      if (res.success) {
        toast.success("Relegation record deleted successfully", { id: loader });
        loadRelegations();
      } else {
        toast.error(res.message || "Failed to delete relegation", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to delete relegation", { id: loader });
    }
  };

  // Handle Delete Appraisal Request
  const handleDeleteRequest = async (id: any) => {
    if (typeof id === "number" || id === "1" || id === "2" || id === "3" || id === "4") {
      setAppraisalList(appraisalList.filter(item => item.id !== id));
      toast.success("Fallback appraisal record deleted");
      return;
    }

    const loader = toast.loading("Deleting appraisal...");
    try {
      const res = await deleteHrAppraisal(id);
      if (res.success) {
        toast.success("Appraisal record deleted successfully", { id: loader });
        loadAppraisals();
      } else {
        toast.error(res.message || "Failed to delete appraisal", { id: loader });
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to delete appraisal", { id: loader });
    }
  };

  // Filter & Search calculation for Appraisal
  const filteredAppraisals = appraisalList.filter(item => {
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      const match = item.name.toLowerCase().includes(q) ||
                    item.newDesignation.toLowerCase().includes(q) ||
                    item.status.toLowerCase().includes(q);
      if (!match) return false;
    }

    if (filterEmployee && item.name !== filterEmployee) return false;
    if (filterAppraisalBy && item.appraisalBy !== filterAppraisalBy) return false;

    if (filterStartDate) {
      const start = new Date(filterStartDate);
      const parts = item.appraisalDate.split("-");
      const appDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (appDate < start) return false;
    }
    if (filterEndDate) {
      const end = new Date(filterEndDate);
      const parts = item.appraisalDate.split("-");
      const appDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (appDate > end) return false;
    }

    return true;
  });

  // Filter & Search calculation for Relegation
  const filteredRelegations = relegationList.filter(item => {
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      const match = item.name.toLowerCase().includes(q) ||
                    item.newDesignation.toLowerCase().includes(q) ||
                    item.status.toLowerCase().includes(q);
      if (!match) return false;
    }

    if (filterRelegationEmployee && item.name !== filterRelegationEmployee) return false;
    if (filterRelegationBy && item.relegatedBy !== filterRelegationBy) return false;

    if (filterRelegationStartDate) {
      const start = new Date(filterRelegationStartDate);
      const parts = item.relegationDate.split("-");
      const appDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (appDate < start) return false;
    }
    if (filterRelegationEndDate) {
      const end = new Date(filterRelegationEndDate);
      const parts = item.relegationDate.split("-");
      const appDate = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (appDate > end) return false;
    }

    return true;
  });

  // Filter & Search calculation for Reward
  const filteredRewards = rewardList.filter(item => {
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      const match = item.name.toLowerCase().includes(q) ||
                    item.rewardRemark.toLowerCase().includes(q) ||
                    item.status.toLowerCase().includes(q);
      if (!match) return false;
    }

    if (filterRewardEmployeeId && item.employeeId !== filterRewardEmployeeId) return false;
    if (filterRewardRewardedById && item.rewardedBy !== filterRewardRewardedById) return false;
    if (filterRewardType && item.rewardType !== filterRewardType) return false;

    if (filterRewardStartDate) {
      const start = new Date(filterRewardStartDate);
      const parts = item.rewardDate.split("-"); // DD-MM-YYYY
      const rewardDateObj = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (rewardDateObj < start) return false;
    }
    if (filterRewardEndDate) {
      const end = new Date(filterRewardEndDate);
      const parts = item.rewardDate.split("-");
      const rewardDateObj = new Date(Number(parts[2]), Number(parts[1]) - 1, Number(parts[0]));
      if (rewardDateObj > end) return false;
    }

    return true;
  });

  const appraisalColumns = [
    {
      label: (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      ),
      render: () => (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      )
    },
    { label:"SR NO.",      render:(_:any,i:number)=><span className="font-medium text-gray-600">{i+1}</span> },
    { label:"EMPLOYEE",    render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-bold flex-shrink-0 uppercase text-amber-800 font-sans shadow-sm">{s.name.charAt(0)}</div>
        <div>
          <div className="font-bold text-[13px] text-[#212121] leading-snug">{s.name}</div>
          <div className="text-[11px] text-gray-400 font-medium">{s.dept}</div>
        </div>
      </div>
    )},
    { label:"APPRAISAL DATE",render:(s:any)=><span className="text-sm font-bold text-gray-700">{s.appraisalDate}</span> },
    { label:"APPRAISAL BY",  render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] font-bold flex-shrink-0 uppercase shadow-sm">{s.appraisalBy.charAt(0)}</div>
        <div>
          <div className="font-bold text-[12px] text-[#212121] leading-snug">{s.appraisalBy}</div>
          <div className="text-[10px] text-gray-400 font-medium">{s.appraisalByDept}</div>
        </div>
      </div>
    )},
    { label:"STATUS",      render:(s:any)=><span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full border shadow-sm ${s.status==="Approved"?"text-emerald-700 bg-emerald-50 border-emerald-200/50":s.status==="Rejected"?"text-rose-700 bg-rose-50 border-rose-200/50":"text-amber-700 bg-amber-50 border-amber-200/50"}`}>● {s.status}</span> },
    { label:"CREATED AT",  render:(s:any)=><div className="text-[10px] font-medium text-gray-500"><div>{s.createdDate}</div><div className="text-gray-400 font-semibold">{s.createdTime}</div></div> },
    { label:"UPDATED AT",  render:(s:any)=><div className="text-[10px] font-medium text-gray-500"><div>{s.updatedDate}</div><div className="text-gray-400 font-semibold">{s.updatedTime}</div></div> },
    { label:"ACTIONS",     render:(s:any)=>(
      <div className={`relative flex justify-center ${openRowMenuId === s.id ? "z-30" : "z-10"}`}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenRowMenuId(openRowMenuId === s.id ? null : s.id);
          }}
          className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#FBD037] hover:bg-[#FBD037]/10 transition cursor-pointer bg-white"
        >
          <IconDotsVertical size={16} className="text-gray-500" />
        </button>

        {openRowMenuId === s.id && (
          <div className="absolute right-0 top-9 w-32 bg-white rounded-xl shadow-lg border border-gray-150 py-1.5 z-40 animate-in fade-in slide-in-from-top-2 duration-150 font-semibold text-slate-700 text-left">
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                setSelectedAppraisal(s);
                setAppraisalPanelType("view");
                setIsAppraisalPanelOpen(true);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer"
            >
              <IconEye size={14} className="text-gray-400" />
              View
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleOpenEdit(s);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer border-t border-gray-100"
            >
              <IconEdit size={14} className="text-gray-400" />
              Edit
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleDeleteRequest(s.id);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-red-600 hover:bg-red-50 transition flex items-center gap-2 cursor-pointer border-t border-gray-100"
            >
              <IconTrash size={14} className="text-red-400" />
              Delete
            </button>
          </div>
        )}
      </div>
    )},
  ];

  const relegationColumns = [
    {
      label: (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      ),
      render: () => (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      )
    },
    { label:"SR NO.",      render:(_:any,i:number)=><span className="font-medium text-gray-600">{i+1}</span> },
    { label:"EMPLOYEE",    render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-bold flex-shrink-0 uppercase text-amber-800 font-sans shadow-sm">{s.name.charAt(0)}</div>
        <div>
          <div className="font-bold text-[13px] text-[#212121] leading-snug">{s.name}</div>
          <div className="text-[11px] text-gray-400 font-medium">{s.dept}</div>
        </div>
      </div>
    )},
    { label:"RELEGATION DATE",render:(s:any)=><span className="text-xs font-bold text-gray-700">{s.relegationDate}</span> },
    { label:"RELEGATION BY",  render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] font-bold flex-shrink-0 uppercase shadow-sm">{s.relegatedBy.charAt(0)}</div>
        <div>
          <div className="font-bold text-[12px] text-[#212121] leading-snug">{s.relegatedBy}</div>
          <div className="text-[10px] text-gray-400 font-medium">{s.relegatedByDept}</div>
        </div>
      </div>
    )},
    { label:"CREATED AT",  render:(s:any)=><div className="text-[10px] font-medium text-gray-500"><div>{s.createdDate}</div><div className="text-gray-400 font-semibold">{s.createdTime}</div></div> },
    { label:"UPDATED AT",  render:(s:any)=><div className="text-[10px] font-medium text-gray-500"><div>{s.updatedDate}</div><div className="text-gray-400 font-semibold">{s.updatedTime}</div></div> },
    { label:"ACTIONS",     render:(s:any)=>(
      <div className={`relative flex justify-center ${openRowMenuId === s.id ? "z-30" : "z-10"}`}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenRowMenuId(openRowMenuId === s.id ? null : s.id);
          }}
          className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#FBD037] hover:bg-[#FBD037]/10 transition cursor-pointer bg-white"
        >
          <IconDotsVertical size={16} className="text-gray-500" />
        </button>

        {openRowMenuId === s.id && (
          <div className="absolute right-0 top-9 w-32 bg-white rounded-xl shadow-lg border border-gray-150 py-1.5 z-40 animate-in fade-in slide-in-from-top-2 duration-150 font-semibold text-slate-700 text-left">
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                setSelectedRelegation(s);
                setRelegationPanelType("view");
                setIsRelegationPanelOpen(true);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer"
            >
              <IconEye size={14} className="text-gray-400" />
              View
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleOpenRelegationEdit(s);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer border-t border-gray-100"
            >
              <IconEdit size={14} className="text-gray-400" />
              Edit
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleDeleteRelegation(s.id);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-red-600 hover:bg-red-50 transition flex items-center gap-2 cursor-pointer border-t border-gray-100"
            >
              <IconTrash size={14} className="text-red-400" />
              Delete
            </button>
          </div>
        )}
      </div>
    )},
  ];

  const rewardColumns = [
    {
      label: (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      ),
      render: () => (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      )
    },
    { label:"SR NO.",      render:(_:any,i:number)=><span className="font-medium text-gray-600">{i+1}</span> },
    { label:"EMPLOYEE ID", render:(s:any)=><span className="font-bold text-xs text-gray-550">{s.employeeIdStr}</span> },
    { label:"EMPLOYEE",    render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-bold flex-shrink-0 uppercase text-amber-800 font-sans shadow-sm">{s.name.charAt(0)}</div>
        <div>
          <div className="font-bold text-[13px] text-[#212121] leading-snug">{s.name}</div>
          <div className="text-[11px] text-gray-400 font-medium">{s.dept}</div>
        </div>
      </div>
    )},
    { label:"REWARD REMARK",render:(s:any)=>(
      <span className="text-xs font-semibold text-gray-700 block max-w-[200px] truncate font-sans" title={s.rewardRemark}>
        {s.rewardRemark || "-"}
      </span>
    )},
    { label:"REWARD DATE",  render:(s:any)=><span className="text-xs font-bold text-gray-750 font-sans">{s.rewardDate}</span> },
    { label:"REWARDED BY",  render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] font-bold flex-shrink-0 uppercase shadow-sm">{s.rewardedBy.charAt(0)}</div>
        <div>
          <div className="font-bold text-[12px] text-[#212121] leading-snug">{s.rewardedBy}</div>
          <div className="text-[10px] text-gray-400 font-medium">{s.rewardedByDept}</div>
        </div>
      </div>
    )},
    { label:"STATUS",      render:(s:any) => {
      const currentStatus = s.status || "Pending";
      return (
        <div className="relative" onClick={(e) => e.stopPropagation()}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setOpenStatusMenuId(openStatusMenuId === s.id ? null : s.id);
            }}
            className={`flex items-center gap-1.5 px-2.5 py-1 rounded-lg border text-xs font-bold transition cursor-pointer select-none font-sans ${
              currentStatus === "Approved"
                ? "text-emerald-700 bg-emerald-55 border-emerald-200/50"
                : currentStatus === "Rejected"
                ? "text-rose-700 bg-rose-55 border-rose-200/50"
                : "text-amber-700 bg-amber-55 border-amber-200/50"
            }`}
          >
            <span>● {currentStatus}</span>
            <IconChevronDown size={12} className="text-gray-400" />
          </button>

          {openStatusMenuId === s.id && (
            <div className="absolute left-0 mt-1 w-28 bg-white rounded-xl shadow-lg border border-gray-150 py-1.5 z-40 text-left font-semibold text-slate-700 animate-in fade-in duration-100">
              {["Pending", "Approved", "Rejected"].map((opt) => (
                <button
                  key={opt}
                  onClick={async (e) => {
                    e.stopPropagation();
                    setOpenStatusMenuId(null);
                    await handleStatusChange(s.id, opt);
                  }}
                  className="w-full text-left px-3.5 py-1.5 text-xs hover:bg-slate-50 transition flex items-center justify-between cursor-pointer font-sans"
                >
                  <span className={`flex items-center gap-1.5 ${
                    opt === "Approved" ? "text-emerald-600" : opt === "Rejected" ? "text-rose-600" : "text-amber-600"
                  }`}>● {opt}</span>
                  {currentStatus.toLowerCase() === opt.toLowerCase() && (
                    <span className="text-[#FBD037] font-bold">✓</span>
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      );
    }},
    { label:"APPROVED BY",  render:(s:any) => {
      if (s.status !== "Approved" || s.approvedBy === "-") {
        return <span className="text-gray-300">-</span>;
      }
      return (
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-blue-50 border border-blue-100 flex items-center justify-center text-[10px] font-bold flex-shrink-0 uppercase shadow-sm text-blue-700">{s.approvedBy.charAt(0)}</div>
          <div>
            <div className="font-bold text-[12px] text-[#212121] leading-snug">{s.approvedBy}</div>
            <div className="text-[10px] text-gray-400 font-medium">{s.approvedByDept}</div>
          </div>
        </div>
      );
    }},
    { label:"ACTIONS",     render:(s:any)=>(
      <div className={`relative flex justify-center ${openRowMenuId === s.id ? "z-30" : "z-10"}`} onClick={(e) => e.stopPropagation()}>
        <button
          onClick={(e) => {
            e.stopPropagation();
            setOpenRowMenuId(openRowMenuId === s.id ? null : s.id);
          }}
          className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#FBD037] hover:bg-[#FBD037]/10 transition cursor-pointer bg-white"
        >
          <IconDotsVertical size={16} className="text-gray-500" />
        </button>

        {openRowMenuId === s.id && (
          <div className="absolute right-0 top-9 w-32 bg-white rounded-xl shadow-lg border border-gray-150 py-1.5 z-40 animate-in fade-in slide-in-from-top-2 duration-150 font-semibold text-slate-700 text-left font-sans">
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                setSelectedReward(s);
                setRewardPanelType("view");
                setIsRewardPanelOpen(true);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer border-none bg-transparent"
            >
              <IconEye size={14} className="text-gray-400" />
              View
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleOpenRewardEdit(s);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-gray-700 hover:bg-slate-55 transition flex items-center gap-2 cursor-pointer border-t border-gray-100 border-none bg-transparent"
            >
              <IconEdit size={14} className="text-gray-400" />
              Edit
            </button>
            <button
              type="button"
              onClick={() => {
                setOpenRowMenuId(null);
                handleDeleteReward(s.id);
              }}
              className="w-full text-left px-3.5 py-2 text-xs font-bold text-red-600 hover:bg-red-50 transition flex items-center gap-2 cursor-pointer border-t border-gray-100 border-none bg-transparent"
            >
              <IconTrash size={14} className="text-red-400" />
              Delete
            </button>
          </div>
        )}
      </div>
    )},
  ];

  const genericActionColumns = [
    {
      label: (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      ),
      render: () => (
        <div className="flex items-center justify-center">
          <label className="relative flex items-center justify-center cursor-pointer h-4 w-4">
            <input
              type="checkbox"
              className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
            />
            <span className="absolute text-[10px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
              ✓
            </span>
          </label>
        </div>
      )
    },
    { label:"SR NO.",      render:(_:any,i:number)=><span className="font-medium text-gray-600">{i+1}</span> },
    { label:"EMPLOYEE",    render:(s:any)=>(
      <div className="flex items-center gap-2">
        <div className="w-9 h-9 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-bold flex-shrink-0">{s.name.charAt(0)}</div>
        <div><div className="font-semibold text-[13px] text-[#212121]">{s.name}</div><div className="text-[11px] text-gray-400">{s.dept}</div></div>
      </div>
    )},
    { label:"ACTION TYPE", render:(s:any)=><span className="text-sm text-gray-700 font-medium">{s.actionType}</span> },
    { label:"PROCESSED BY",render:(s:any)=>s.processedBy?(
      <div className="flex items-center gap-2">
        <div className="w-7 h-7 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-[10px] font-bold flex-shrink-0">{s.processedBy.charAt(0)}</div>
        <div><div className="font-semibold text-[12px] text-[#212121]">{s.processedBy}</div><div className="text-[10px] text-gray-400">{s.processedByDept}</div></div>
      </div>
    ):<span className="text-gray-300">-</span>},
    { label:"STATUS",      render:(s:any)=><span className={`text-xs font-semibold px-2 py-0.5 rounded-full border ${s.status==="Approved"?"text-green-600 bg-green-50 border-green-200":s.status==="Rejected"?"text-red-600 bg-red-50 border-red-200":s.status==="Pending"?"text-orange-600 bg-orange-50 border-orange-200":"text-gray-600 bg-gray-100 border-gray-200"}`}>● {s.status}</span> },
    { label:"CREATED AT",  render:(s:any)=><div className="text-xs"><div className="font-medium text-gray-700">{s.createdDate}</div><div className="text-gray-400">{s.createdTime}</div></div> },
    { label:"UPDATED AT",  render:(s:any)=><div className="text-xs"><div className="font-medium text-gray-700">{s.updatedDate}</div><div className="text-gray-400">{s.updatedTime}</div></div> },
    { label:"ACTIONS",     render:()=><div className="flex justify-center"><button className="w-8 h-8 rounded-full border border-gray-200 flex items-center justify-center hover:border-[#FBD037] hover:bg-[#FBD037]/10 transition"><svg className="w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg></button></div> },
  ];

  const genericActionData = [
    { id:1, name:"Sushil Rathore", dept:"Human Resources",      actionType:"Resign", processedBy:"", processedByDept:"", status:"Pending", createdDate:"01-05-2026", createdTime:"06:12 PM", updatedDate:"01-05-2026", updatedTime:"06:12 PM" },
    { id:2, name:"Priya Sharma",   dept:"IT & Support",         actionType:"Resign", processedBy:"Arjun Kapoor", processedByDept:"Project", status:"Approved", createdDate:"14-10-2025", createdTime:"04:46 PM", updatedDate:"19-12-2025", updatedTime:"12:48 PM" },
    { id:3, name:"Rahul Verma",    dept:"Software Development", actionType:"Terminate", processedBy:"Sneha Joshi", processedByDept:"HR", status:"Rejected", createdDate:"14-10-2025", createdTime:"04:43 PM", updatedDate:"20-04-2026", updatedTime:"01:09 PM" },
    { id:4, name:"Anita Desai",    dept:"Legal & Compliance",   actionType:"Resign", processedBy:"", processedByDept:"", status:"Cancelled", createdDate:"14-10-2025", createdTime:"03:29 PM", updatedDate:"14-03-2026", updatedTime:"07:25 PM" },
  ];

  const columns = actionSubTab === "Appraisal" 
    ? appraisalColumns 
    : actionSubTab === "Relegation" 
    ? relegationColumns 
    : actionSubTab === "Rewards"
    ? rewardColumns
    : genericActionColumns;

  const data = actionSubTab === "Appraisal" 
    ? filteredAppraisals 
    : actionSubTab === "Relegation" 
    ? filteredRelegations 
    : actionSubTab === "Rewards"
    ? filteredRewards
    : genericActionData;

  return (
    <div 
      className="w-full mx-auto mt-2 animate-in fade-in duration-300 font-sans"
      onClick={() => setOpenRowMenuId(null)}
    >
      {isLoading && (
        <div className="fixed inset-0 bg-white/40 backdrop-blur-[1px] z-50 flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FBD037]" />
        </div>
      )}

      {/* Action inner sub-tabs */}
      <div className="flex mb-3 w-full px-2">
        <div className="flex flex-wrap gap-1 bg-[#E4E7EB] rounded-xl p-1 font-sans text-xs font-bold shadow-inner w-fit">
          {["Appraisal","Relegation","Action","Fine","Warning","Rewards","Expense Request"].map(t=>(
            <button key={t} onClick={() => {
              setActionSubTab(t);
              setIsRelegationPanelOpen(false);
              setIsAppraisalPanelOpen(false);
              setIsRewardPanelOpen(false);
            }}
              className={`px-4 py-1.5 rounded-lg transition-all cursor-pointer ${actionSubTab===t?"bg-white text-gray-900 shadow-sm":"text-gray-500 hover:text-gray-700"}`}>{t}</button>
          ))}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row gap-4 items-start w-full">
        
        {/* Left Side: Main table layout */}
        <div className="flex-1 w-full bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl rounded-b-3xl rounded-tr-3xl border border-white/20 shadow-sm overflow-hidden mb-6">
          
          {/* Toolbar Controls */}
          <div className="px-6 py-2.5 flex flex-col lg:flex-row lg:items-center justify-between gap-4 border-b border-slate-50">
            <h1 className="text-lg text-[#212121] tracking-tight font-bold whitespace-nowrap text-left">
              {actionSubTab}
            </h1>

            <div className="flex items-center flex-wrap gap-2.5">
              
              {/* Appraisal Tab Toolbar buttons */}
              {actionSubTab === "Appraisal" && (
                <>
                  <button
                    onClick={() => {
                      setAppraisalPanelType("filter");
                      setIsAppraisalPanelOpen(!isAppraisalPanelOpen);
                    }}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold transition cursor-pointer ${
                      isAppraisalPanelOpen && appraisalPanelType === "filter" ? "bg-[#FBD037]/10 border-[#FBD037] text-amber-900" : "bg-white border-slate-200 text-slate-700 hover:bg-gray-55"
                    }`}
                  >
                    <IconFilter size={14} />
                    Filter
                  </button>

                  <button
                    onClick={() => {
                      setAppraisalPanelType("import");
                      setIsAppraisalPanelOpen(true);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconUpload size={14} className="text-gray-400" />
                    Import
                  </button>

                  <button
                    onClick={() => toast.success("Data export initiated")}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconDownload size={14} className="text-gray-400" />
                    Export
                  </button>
                </>
              )}

              {/* Relegation Tab Toolbar buttons */}
              {actionSubTab === "Relegation" && (
                <>
                  <button
                    onClick={() => {
                      setRelegationPanelType("filter");
                      setIsRelegationPanelOpen(!isRelegationPanelOpen);
                    }}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold transition cursor-pointer ${
                      isRelegationPanelOpen && relegationPanelType === "filter" ? "bg-[#FBD037]/10 border-[#FBD037] text-amber-900" : "bg-white border-slate-200 text-slate-700 hover:bg-gray-55"
                    }`}
                  >
                    <IconFilter size={14} />
                    Filter
                  </button>

                  <button
                    onClick={() => {
                      setRelegationPanelType("import");
                      setIsRelegationPanelOpen(true);
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconUpload size={14} className="text-gray-400" />
                    Import
                  </button>

                  <button
                    onClick={() => toast.success("Relegation export initiated")}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconDownload size={14} className="text-gray-400" />
                    Export
                  </button>
                </>
              )}

              {/* Rewards Tab Toolbar buttons */}
              {actionSubTab === "Rewards" && (
                <>
                  <button
                    onClick={() => {
                      setRewardPanelType("filter");
                      setIsRewardPanelOpen(!isRewardPanelOpen);
                    }}
                    className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg border text-xs font-bold transition cursor-pointer ${
                      isRewardPanelOpen && rewardPanelType === "filter" ? "bg-[#FBD037]/10 border-[#FBD037] text-amber-900" : "bg-white border-slate-200 text-slate-700 hover:bg-gray-55"
                    }`}
                  >
                    <IconFilter size={14} />
                    Filter
                  </button>

                  <button
                    onClick={() => {
                      toast.success("Rewards template download initiated");
                    }}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconUpload size={14} className="text-gray-400" />
                    Import
                  </button>

                  <button
                    onClick={() => toast.success("Rewards export initiated")}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer"
                  >
                    <IconDownload size={14} className="text-gray-400" />
                    Export
                  </button>
                </>
              )}

              {/* Search Box */}
              <div className="flex items-center gap-2 relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <IconSearch size={15} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="pl-9 pr-4 h-8 rounded-lg border border-slate-200 bg-white text-xs outline-none focus:ring-1 focus:ring-[#FBD037] transition w-44 text-left"
                />
              </div>

              {/* Add Action button */}
              {actionSubTab === "Appraisal" && (
                <button
                  onClick={() => {
                    setFormEmployeeId("");
                    setFormOldDesignation("");
                    setFormOldDesignationId("");
                    setFormNewDesignation("");
                    setFormEffectiveDate("");
                    setFormOldCtc("");
                    setFormNewCtc("");
                    setFormRemarks("");
                    setAppraisalPanelType("add");
                    setIsAppraisalPanelOpen(true);
                  }}
                  className="flex items-center gap-1.5 h-8 px-3.5 rounded-lg bg-black hover:bg-slate-800 text-white font-bold text-xs shadow-sm transition active:scale-95 cursor-pointer animate-in fade-in"
                >
                  <IconPlus stroke={3} size={13} />
                  Add Appraisal
                </button>
              )}

              {actionSubTab === "Relegation" && (
                <button
                  onClick={() => {
                    setRelegationEmployeeId("");
                    setRelegationOldDesignation("");
                    setRelegationOldDesignationId("");
                    setRelegationNewDesignation("");
                    setRelegationEffectiveDate("");
                    setRelegationOldCtc("");
                    setRelegationNewCtc("");
                    setRelegationRemarks("");
                    setRelegationPanelType("add");
                    setIsRelegationPanelOpen(true);
                  }}
                  className="flex items-center gap-1.5 h-8 px-3.5 rounded-lg bg-black hover:bg-slate-800 text-white font-bold text-xs shadow-sm transition active:scale-95 cursor-pointer animate-in fade-in"
                >
                  <IconPlus stroke={3} size={13} />
                  Add Relegation
                </button>
              )}

              {actionSubTab === "Rewards" && (
                <button
                  onClick={() => {
                    setRewardEmployeeId("");
                    setRewardDate(new Date().toISOString().split("T")[0]);
                    setRewardType("NonMonetary");
                    setRewardLinkAppreciation(false);
                    setRewardReason("");
                    setRewardPanelType("add");
                    setIsRewardPanelOpen(true);
                  }}
                  className="flex items-center gap-1.5 h-8 px-3.5 rounded-lg bg-black hover:bg-slate-800 text-white font-bold text-xs shadow-sm transition active:scale-95 cursor-pointer animate-in fade-in"
                >
                  <IconPlus stroke={3} size={13} />
                  Add Rewards
                </button>
              )}
            </div>
          </div>

          {/* Data Table */}
          <div className="pb-4 mt-0 overflow-x-auto">
            <ListView
              columns={columns}
              data={data}
              trClassName="hover:bg-[#FBD037]/10 group transition-colors duration-150 border-b border-gray-100 cursor-pointer"
              mainDivClassName="bg-[#F7F6F2] rounded-3xl"
              mailDivClassName="custom-scrollbar bg-[#FCFDF8] rounded-3xl shadow-inner max-h-[75vh] min-h-[250px]"
              scrollbarClassName="custom-scrollbar"
              thClassName="text-[11px] font-semibold tracking-wider uppercase select-none text-[#131327]/70"
            />
            {data.length === 0 && (
              <div className="text-center py-12 text-sm text-gray-400 font-medium">
                No action records match search filter.
              </div>
            )}
            
            <div className="py-4 flex justify-between items-center px-6">
              <span className="text-xs text-gray-400 font-bold">
                Showing {data.length} records
              </span>
              <div className="flex items-center space-x-2">
                <button className="p-1 rounded-md border text-gray-400 hover:bg-gray-50 disabled:opacity-50" disabled>
                  <IconChevronLeft size={18} />
                </button>
                <button className="px-2.5 py-0.5 rounded-md bg-[#FBD037] text-[#212121] font-bold text-xs shadow-sm">1</button>
                <button className="p-1 rounded-md border text-gray-400 hover:bg-gray-55">
                  <IconChevronRight size={18} />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Ap        {/* Right Side: Appraisal Sidebar Panel */}
        {actionSubTab === "Appraisal" && isAppraisalPanelOpen && (
          <div className="w-full lg:w-[430px] flex-shrink-0 border border-gray-200 rounded-2xl bg-[#F7F6F2] shadow-sm flex flex-col h-[calc(100vh-170px)] sticky top-[95px] overflow-hidden animate-in slide-in-from-right-10 duration-200">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#E9E9E9] shrink-0 bg-white/70 backdrop-blur-md">
              <div className="flex items-center gap-2">
                <IconCalendar size={18} className="text-[#C9A100]" />
                <h2 className="text-[#212121] text-xs font-bold uppercase tracking-wide">
                  {appraisalPanelType === "add"
                    ? "Add New Appraisal"
                    : appraisalPanelType === "edit"
                    ? "Update Appraisal"
                    : appraisalPanelType === "import"
                    ? "Import Appraisal"
                    : appraisalPanelType === "view"
                    ? "Appraisal Details"
                    : "Filter Appraisal"}
                </h2>
              </div>
              <button
                onClick={() => setIsAppraisalPanelOpen(false)}
                className="p-1 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors text-slate-700 cursor-pointer bg-white"
              >
                <IconX size={16} />
              </button>
            </div>

            {/* Scrollable Form Content */}
            <div className="flex-1 overflow-y-auto p-5 text-left text-slate-700 space-y-4">
              
              {/* Add & Edit Appraisal Form */}
              {(appraisalPanelType === "add" || appraisalPanelType === "edit") && (
                <form 
                  onSubmit={appraisalPanelType === "add" ? handleAddSubmit : handleEditSubmit} 
                  className="space-y-4"
                >
                  <SectionBlock title="Appraisal Details" icon={IconCalendar}>
                    <div className="space-y-3.5">
                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee <span className="text-red-500">*</span></label>
                        <select
                          required
                          disabled={appraisalPanelType === "edit"}
                          value={formEmployeeId}
                          onChange={(e) => setFormEmployeeId(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer disabled:bg-gray-100"
                        >
                          <option value="">Select Employee</option>
                          {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Old Designation</label>
                        <input
                          type="text"
                          disabled
                          placeholder="Auto-populated"
                          value={formOldDesignation}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-gray-50 border border-[#D8D8D8] text-gray-500 font-semibold"
                        />
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">New Designation <span className="text-red-500">*</span></label>
                        <select
                          required
                          value={formNewDesignation}
                          onChange={(e) => setFormNewDesignation(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Designation...</option>
                          {designations.map((d) => (
                            <option key={d.id} value={d.id}>{d.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Effective Date <span className="text-red-500">*</span></label>
                        <input
                          type="date"
                          required
                          value={formEffectiveDate}
                          onChange={(e) => setFormEffectiveDate(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Old CTC</label>
                          <input
                            type="number"
                            placeholder="Ex. 10000"
                            value={formOldCtc}
                            onChange={(e) => setFormOldCtc(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">New CTC</label>
                          <input
                            type="number"
                            placeholder="Ex. 11000"
                            value={formNewCtc}
                            onChange={(e) => setFormNewCtc(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Increment Amount</label>
                          <div className="relative">
                            <span className="absolute left-3.5 top-2.5 text-gray-400 text-xs">₹</span>
                            <input
                              type="text"
                              disabled
                              value={calculatedIncrement}
                              className="w-full pl-7 pr-4 py-[10px] rounded-xl text-xs bg-emerald-50/40 text-emerald-800 border border-[#D8D8D8] outline-none font-bold"
                            />
                          </div>
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Increment %</label>
                          <input
                            type="text"
                            disabled
                            value={`${calculatedPercent}%`}
                            className="w-full px-4 py-[10px] rounded-xl text-xs bg-blue-50/40 text-blue-800 border border-[#D8D8D8] outline-none font-bold"
                          />
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Remarks <span className="text-red-500">*</span></label>
                        <textarea
                          required
                          rows={3}
                          placeholder="Enter remarks..."
                          value={formRemarks}
                          onChange={(e) => setFormRemarks(e.target.value)}
                          className="w-full rounded-xl py-2 px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold resize-none"
                        />
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Footer buttons */}
                  <div className="pt-2 flex justify-end gap-3 border-t border-gray-100">
                    <button
                      type="button"
                      onClick={() => setIsAppraisalPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Save
                    </button>
                  </div>
                </form>
              )}

              {/* View Appraisal Details Panel */}
              {appraisalPanelType === "view" && selectedAppraisal && (
                <div className="space-y-4">
                  {/* Employee Info Card */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-2">Employee Info</h4>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-black text-[#8C6D00] uppercase shadow-sm">
                        {selectedAppraisal.name.charAt(0)}
                      </div>
                      <div>
                        <h5 className="font-extrabold text-sm text-slate-800 leading-snug">{selectedAppraisal.name}</h5>
                        <p className="text-[11px] text-gray-400 font-medium">{selectedAppraisal.dept}</p>
                        <p className="text-[10px] text-gray-400 font-medium">testing1234@gmail.com</p>
                      </div>
                    </div>
                  </div>

                  {/* Appraisal Info Card */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm space-y-3.5 text-xs font-semibold">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-1">Appraisal Info</h4>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Old Designation:</span>
                      <span className="text-slate-800">{selectedAppraisal.oldDesignation}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">New Designation:</span>
                      <span className="text-slate-800">{selectedAppraisal.newDesignation}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Old CTC:</span>
                      <span className="text-slate-800">₹ {selectedAppraisal.oldCtc.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">New CTC:</span>
                      <span className="text-slate-800">₹ {selectedAppraisal.newCtc.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Increment Amount:</span>
                      <span className="text-emerald-700 font-bold">₹ {selectedAppraisal.incrementAmount.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Increment %:</span>
                      <span className="text-blue-700 font-bold">{selectedAppraisal.incrementPercent}%</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Effective Date:</span>
                      <span className="text-slate-800">{selectedAppraisal.effectiveDate}</span>
                    </div>
                    <div className="flex justify-between pb-1">
                      <span className="text-gray-400">Appraisal Date:</span>
                      <span className="text-slate-800">{selectedAppraisal.appraisalDate}</span>
                    </div>
                  </div>

                  {/* Appraised By card */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-2">Appraised By</h4>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-xs font-bold uppercase shadow-sm">
                        {selectedAppraisal.appraisalBy.charAt(0)}
                      </div>
                      <div>
                        <h5 className="font-extrabold text-sm text-slate-800 leading-snug">{selectedAppraisal.appraisalBy}</h5>
                        <p className="text-[11px] text-gray-400 font-medium">{selectedAppraisal.appraisalByDept}</p>
                        <p className="text-[10px] text-gray-400 font-medium">{selectedAppraisal.appraisalByEmail || "sandeep.ywppl@gmail.com"}</p>
                      </div>
                    </div>
                  </div>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-end gap-2 border-t border-gray-100">
                    <button
                      onClick={() => setIsAppraisalPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-50 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}

              {/* Import Appraisal Panel */}
              {appraisalPanelType === "import" && (
                <div className="space-y-4">
                  <div className="p-4 rounded-2xl border border-amber-250/30 bg-[#FBD037]/10 flex flex-col gap-1 text-xs">
                    <div className="font-bold text-slate-800">
                      Before uploading the sheet, please ensure that the following fields are included:
                    </div>
                    <div className="text-gray-500 font-medium mt-1">
                      Make sure headers match exactly. Missing fields may cause import errors.
                      <span className="text-amber-600 hover:underline font-bold ml-1.5 cursor-pointer">Show fields</span>
                    </div>
                  </div>

                  <div className="p-4 rounded-2xl border border-gray-150 bg-white flex items-center justify-between gap-4 shadow-sm">
                    <div className="text-xs">
                      <div className="font-bold text-slate-800">Sample Template File</div>
                      <div className="text-gray-400 font-medium">Download the Excel structure.</div>
                    </div>
                    <button
                      onClick={() => toast.success("Sample template downloaded")}
                      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer shrink-0 animate-in hover:shadow-sm"
                    >
                      <IconDownload size={14} className="text-gray-400" />
                      Download
                    </button>
                  </div>

                  {/* Drag drop target */}
                  <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-white relative">
                    <input
                      type="file"
                      className="absolute inset-0 opacity-0 cursor-pointer"
                      onChange={() => toast.success("File selected")}
                    />
                    <IconUpload size={28} className="text-gray-400" />
                    <div className="text-xs font-bold text-slate-800 text-center">
                      Click or drag file here
                    </div>
                    <span className="mt-1 px-3 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-[10px] font-bold uppercase text-slate-600 transition tracking-wide">
                      Choose file
                    </span>
                  </div>

                  {/* Action buttons */}
                  <div className="pt-2 flex justify-end gap-3 border-t border-gray-100">
                    <button
                      onClick={() => setIsAppraisalPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-50 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        setIsAppraisalPanelOpen(false);
                        toast.success("Excel editor opened");
                      }}
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Open Editor
                    </button>
                  </div>
                </div>
              )}

              {/* Filter Appraisal Panel */}
              {appraisalPanelType === "filter" && (
                <div className="space-y-4">
                  <SectionBlock title="Filter Criteria" icon={IconFilter}>
                    <div className="space-y-3.5">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Start Date</label>
                          <input
                            type="date"
                            value={filterStartDate}
                            onChange={(e) => setFilterStartDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">End Date</label>
                          <input
                            type="date"
                            value={filterEndDate}
                            onChange={(e) => setFilterEndDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee</label>
                        <select
                          value={filterEmployee}
                          onChange={(e) => setFilterEmployee(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Employee</option>
                          {Array.from(new Set(appraisalList.map(e => e.name))).map((name) => (
                            <option key={name} value={name}>{name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Appraisal By</label>
                        <select
                          value={filterAppraisalBy}
                          onChange={(e) => setFilterAppraisalBy(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Appraised By</option>
                          {Array.from(new Set(appraisalList.map(e => e.appraisalBy))).map((by) => (
                            <option key={by} value={by}>{by}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-between gap-3 border-t border-gray-100">
                    <button
                      onClick={() => {
                        setFilterStartDate("");
                        setFilterEndDate("");
                        setFilterEmployee("");
                        setFilterAppraisalBy("");
                        toast.success("Filters cleared");
                      }}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Clear All
                    </button>
                    <button
                      onClick={() => setIsAppraisalPanelOpen(false)}
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}

        {/* Right S        {/* Right Side: Relegation Sidebar Panel */}
        {actionSubTab === "Relegation" && isRelegationPanelOpen && (
          <div className="w-full lg:w-[430px] flex-shrink-0 border border-gray-200 rounded-2xl bg-[#F7F6F2] shadow-sm flex flex-col h-[calc(100vh-170px)] sticky top-[95px] overflow-hidden animate-in slide-in-from-right-10 duration-200">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#E9E9E9] shrink-0 bg-white/70 backdrop-blur-md">
              <div className="flex items-center gap-2">
                <IconCalendar size={18} className="text-[#C9A100]" />
                <h2 className="text-[#212121] text-xs font-bold uppercase tracking-wide">
                  {relegationPanelType === "add"
                    ? "Add New Relegation"
                    : relegationPanelType === "edit"
                    ? "Update Relegation"
                    : relegationPanelType === "import"
                    ? "Import Relegation"
                    : relegationPanelType === "view"
                    ? "Relegation Details"
                    : "Filter Relegation"}
                </h2>
              </div>
              <button
                onClick={() => setIsRelegationPanelOpen(false)}
                className="p-1 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors text-slate-700 cursor-pointer bg-white"
              >
                <IconX size={16} />
              </button>
            </div>

            {/* Scrollable Form Content */}
            <div className="flex-1 overflow-y-auto p-5 text-left text-slate-700 space-y-4">
              
              {/* Add & Edit Relegation form panel */}
              {(relegationPanelType === "add" || relegationPanelType === "edit") && (
                <form 
                  onSubmit={relegationPanelType === "add" ? handleAddRelegationSubmit : handleEditRelegationSubmit} 
                  className="space-y-4"
                >
                  <SectionBlock title="Relegation Details" icon={IconCalendar}>
                    <div className="space-y-3.5">
                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee <span className="text-red-500">*</span></label>
                        <select
                          required
                          disabled={relegationPanelType === "edit"}
                          value={relegationEmployeeId}
                          onChange={(e) => setRelegationEmployeeId(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer disabled:bg-gray-100"
                        >
                          <option value="">Select Employee</option>
                          {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Old Designation</label>
                        <input
                          type="text"
                          disabled
                          placeholder="Select option..."
                          value={relegationOldDesignation}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-gray-55 border border-[#D8D8D8] text-gray-500 font-semibold"
                        />
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">New Designation <span className="text-red-500">*</span></label>
                        <select
                          required
                          value={relegationNewDesignation}
                          onChange={(e) => setRelegationNewDesignation(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Designation...</option>
                          {designations.map((d) => (
                            <option key={d.id} value={d.id}>{d.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Effective Date <span className="text-red-500">*</span></label>
                        <input
                          type="date"
                          required
                          value={relegationEffectiveDate}
                          onChange={(e) => setRelegationEffectiveDate(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Old CTC</label>
                          <input
                            type="number"
                            placeholder="Ex. 10000"
                            value={relegationOldCtc}
                            onChange={(e) => setRelegationOldCtc(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">New CTC</label>
                          <input
                            type="number"
                            placeholder="Ex. 9000"
                            value={relegationNewCtc}
                            onChange={(e) => setRelegationNewCtc(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>
                      </div>

                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Decrement Amount</label>
                          <div className="relative">
                            <span className="absolute left-3.5 top-2.5 text-gray-400 text-xs">₹</span>
                            <input
                              type="text"
                              disabled
                              value={calculatedDecrement}
                              className="w-full pl-7 pr-4 py-[10px] rounded-xl text-xs bg-rose-50/40 text-rose-800 border border-[#D8D8D8] outline-none font-bold"
                            />
                          </div>
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Decrement (%)</label>
                          <input
                            type="text"
                            disabled
                            value={`${calculatedDecrementPercent}%`}
                            className="w-full px-4 py-[10px] rounded-xl text-xs bg-blue-50/40 text-blue-800 border border-[#D8D8D8] outline-none font-bold"
                          />
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Remarks <span className="text-red-500">*</span></label>
                        <textarea
                          required
                          rows={3}
                          placeholder="Enter remarks..."
                          value={relegationRemarks}
                          onChange={(e) => setRelegationRemarks(e.target.value)}
                          className="w-full rounded-xl py-2 px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold resize-none"
                        />
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Footer buttons */}
                  <div className="pt-2 flex justify-end gap-3 border-t border-gray-100">
                    <button
                      type="button"
                      onClick={() => setIsRelegationPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Save
                    </button>
                  </div>
                </form>
              )}

              {/* View Relegation Details Panel */}
              {relegationPanelType === "view" && selectedRelegation && (
                <div className="space-y-4">
                  {/* Employee Info Card */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-2">Employee Info</h4>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/40 flex items-center justify-center text-sm font-black text-[#8C6D00] uppercase shadow-sm">
                        {selectedRelegation.name.charAt(0)}
                      </div>
                      <div>
                        <h5 className="font-extrabold text-sm text-slate-800 leading-snug">{selectedRelegation.name}</h5>
                        <p className="text-[11px] text-gray-400 font-medium">{selectedRelegation.dept}</p>
                        <p className="text-[10px] text-gray-400 font-medium">testing1234@gmail.com</p>
                      </div>
                    </div>
                  </div>

                  {/* Relegation Info Values */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm space-y-3.5 text-xs font-semibold">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-1">Relegation Info</h4>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Old Designation:</span>
                      <span className="text-slate-800">{selectedRelegation.oldDesignation}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">New Designation:</span>
                      <span className="text-slate-800">{selectedRelegation.newDesignation}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Old CTC:</span>
                      <span className="text-slate-800">₹ {selectedRelegation.oldCtc.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">New CTC:</span>
                      <span className="text-slate-800">₹ {selectedRelegation.newCtc.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Decrement Amount:</span>
                      <span className="text-rose-700 font-bold">₹ {selectedRelegation.decrementAmount.toLocaleString()}</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Decrement %:</span>
                      <span className="text-blue-700 font-bold">{selectedRelegation.decrementPercent}%</span>
                    </div>
                    <div className="flex justify-between border-b border-dashed border-gray-100 pb-2">
                      <span className="text-gray-400">Effective Date:</span>
                      <span className="text-slate-800">{selectedRelegation.effectiveDate}</span>
                    </div>
                    <div className="flex justify-between pb-1">
                      <span className="text-gray-400">Relegation Date:</span>
                      <span className="text-slate-800">{selectedRelegation.relegationDate}</span>
                    </div>
                  </div>

                  {/* Appraised/Relegated By card */}
                  <div className="bg-white rounded-2xl border border-gray-100 p-4 shadow-sm">
                    <h4 className="text-[10px] font-bold text-[#C9A100] uppercase tracking-wider mb-2">Relegated By</h4>
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-xs font-bold uppercase shadow-sm">
                        {selectedRelegation.relegatedBy.charAt(0)}
                      </div>
                      <div>
                        <h5 className="font-extrabold text-sm text-slate-800 leading-snug">{selectedRelegation.relegatedBy}</h5>
                        <p className="text-[11px] text-gray-400 font-medium">{selectedRelegation.relegatedByDept}</p>
                        <p className="text-[10px] text-gray-400 font-medium">{selectedRelegation.relegatedByEmail || "sandeep.ywppl@gmail.com"}</p>
                      </div>
                    </div>
                  </div>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-end gap-2 border-t border-gray-100">
                    <button
                      onClick={() => setIsRelegationPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-50 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}

              {/* Import Relegation Panel */}
              {relegationPanelType === "import" && (
                <div className="space-y-4">
                  <div className="p-4 rounded-2xl border border-amber-250/30 bg-[#FBD037]/10 flex flex-col gap-1 text-xs">
                    <div className="font-bold text-slate-800">
                      Before uploading the sheet, please ensure that the following fields are included:
                    </div>
                    <div className="text-gray-500 font-medium mt-1">
                      Make sure headers match exactly. Missing fields may cause import errors.
                      <span className="text-amber-600 hover:underline font-bold ml-1.5 cursor-pointer">Show fields</span>
                    </div>
                  </div>

                  <div className="p-4 rounded-2xl border border-gray-150 bg-white flex items-center justify-between gap-4 shadow-sm">
                    <div className="text-xs">
                      <div className="font-bold text-slate-800">Sample Template File</div>
                      <div className="text-gray-400 font-medium">Download the Excel structure.</div>
                    </div>
                    <button
                      onClick={() => toast.success("Sample template downloaded")}
                      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-200 bg-white hover:bg-gray-55 text-xs font-bold text-slate-700 transition cursor-pointer shrink-0 animate-in hover:shadow-sm"
                    >
                      <IconDownload size={14} className="text-gray-400" />
                      Download
                    </button>
                  </div>

                  {/* Drag drop target */}
                  <div className="border-2 border-dashed border-gray-200 hover:border-[#FBD037] transition rounded-2xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-white relative">
                    <input
                      type="file"
                      className="absolute inset-0 opacity-0 cursor-pointer"
                      onChange={() => toast.success("File selected")}
                    />
                    <IconUpload size={28} className="text-gray-400" />
                    <div className="text-xs font-bold text-slate-800 text-center">
                      Click or drag file here
                    </div>
                    <span className="mt-1 px-3 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-[10px] font-bold uppercase text-slate-600 transition tracking-wide">
                      Choose file
                    </span>
                  </div>

                  {/* Action buttons */}
                  <div className="pt-2 flex justify-end gap-3 border-t border-gray-100">
                    <button
                      onClick={() => setIsRelegationPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-50 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        setIsRelegationPanelOpen(false);
                        toast.success("Excel editor opened");
                      }}
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Open Editor
                    </button>
                  </div>
                </div>
              )}

              {/* Filter Relegation Panel */}
              {relegationPanelType === "filter" && (
                <div className="space-y-4">
                  <SectionBlock title="Filter Criteria" icon={IconFilter}>
                    <div className="space-y-3.5">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Start Date</label>
                          <input
                            type="date"
                            value={filterRelegationStartDate}
                            onChange={(e) => setFilterRelegationStartDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">End Date</label>
                          <input
                            type="date"
                            value={filterRelegationEndDate}
                            onChange={(e) => setFilterRelegationEndDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee</label>
                        <select
                          value={filterRelegationEmployee}
                          onChange={(e) => setFilterRelegationEmployee(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Employee</option>
                          {Array.from(new Set(relegationList.map(e => e.name))).map((name) => (
                            <option key={name} value={name}>{name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Relegation By</label>
                        <select
                          value={filterRelegationBy}
                          onChange={(e) => setFilterRelegationBy(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Relegated By</option>
                          {Array.from(new Set(relegationList.map(e => e.relegatedBy))).map((by) => (
                            <option key={by} value={by}>{by}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-between gap-3 border-t border-gray-100">
                    <button
                      onClick={() => {
                        setFilterRelegationStartDate("");
                        setFilterRelegationEndDate("");
                        setFilterRelegationEmployee("");
                        setFilterRelegationBy("");
                        toast.success("Filters cleared");
                      }}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Clear All
                    </button>
                    <button
                      onClick={() => setIsRelegationPanelOpen(false)}
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}

        {/* Right Side: Rewards Sidebar Panel */}
        {actionSubTab === "Rewards" && isRewardPanelOpen && (
          <div className="w-full lg:w-[430px] flex-shrink-0 border border-gray-200 rounded-2xl bg-[#F7F6F2] shadow-sm flex flex-col h-[calc(100vh-170px)] sticky top-[95px] overflow-hidden animate-in slide-in-from-right-10 duration-200">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#E9E9E9] shrink-0 bg-white/70 backdrop-blur-md">
              <div className="flex items-center gap-2">
                <IconCalendar size={18} className="text-[#C9A100]" />
                <h2 className="text-[#212121] text-xs font-bold uppercase tracking-wide">
                  {rewardPanelType === "add"
                    ? "Add New Reward"
                    : rewardPanelType === "edit"
                    ? "Update Reward"
                    : rewardPanelType === "view"
                    ? "Reward Details"
                    : "Filter Rewards"}
                </h2>
              </div>
              <button
                onClick={() => setIsRewardPanelOpen(false)}
                className="p-1 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors text-slate-700 cursor-pointer bg-white"
              >
                <IconX size={16} />
              </button>
            </div>

            {/* Scrollable Form Content */}
            <div className="flex-1 overflow-y-auto p-5 text-left text-slate-700 space-y-4 font-sans">
              
              {/* Add & Edit Reward Form */}
              {(rewardPanelType === "add" || rewardPanelType === "edit") && (
                <form 
                  onSubmit={rewardPanelType === "add" ? handleAddRewardSubmit : handleEditRewardSubmit} 
                  className="space-y-4"
                >
                  <SectionBlock title="Reward Details" icon={IconCalendar}>
                    <div className="space-y-3.5">
                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee <span className="text-red-500">*</span></label>
                        <select
                          required
                          disabled={rewardPanelType === "edit"}
                          value={rewardEmployeeId}
                          onChange={(e) => setRewardEmployeeId(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer disabled:bg-gray-100"
                        >
                          <option value="">Select Employee</option>
                          {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Reward Date <span className="text-red-500">*</span></label>
                        <input
                          type="date"
                          required
                          value={rewardDate}
                          onChange={(e) => setRewardDate(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                        />
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Reward Type <span className="text-red-500">*</span></label>
                        <select
                          required
                          value={rewardType}
                          onChange={(e) => setRewardType(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="NonMonetary">NonMonetary</option>
                          <option value="Monetary">Monetary</option>
                        </select>
                      </div>

                      <div className="space-y-2 pt-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Link Appreciation</label>
                        <div className="flex items-center gap-6">
                          <label className="relative flex items-center gap-2 text-xs text-[#212121] font-semibold cursor-pointer">
                            <input
                              type="radio"
                              name="linkAppreciation"
                              checked={!rewardLinkAppreciation}
                              onChange={() => setRewardLinkAppreciation(false)}
                              className="peer h-4 w-4 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                            />
                            <span className="absolute left-[3px] top-[7px] text-[8px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                              ✓
                            </span>
                            <span>No</span>
                          </label>
                          <label className="relative flex items-center gap-2 text-xs text-[#212121] font-semibold cursor-pointer">
                            <input
                              type="radio"
                              name="linkAppreciation"
                              checked={rewardLinkAppreciation}
                              onChange={() => setRewardLinkAppreciation(true)}
                              className="peer h-4 w-4 cursor-pointer appearance-none rounded-full border border-slate-300 checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
                            />
                            <span className="absolute left-[3px] top-[7px] text-[8px] font-bold text-[#131327] peer-checked:opacity-100 opacity-0 pointer-events-none">
                              ✓
                            </span>
                            <span>Yes</span>
                          </label>
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Reason</label>
                        <textarea
                          value={rewardReason}
                          onChange={(e) => setRewardReason(e.target.value)}
                          placeholder="Enter Reason..."
                          rows={4}
                          className="w-full rounded-xl py-2 px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold resize-none"
                        />
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Footer buttons */}
                  <div className="pt-2 flex justify-end gap-3 border-t border-gray-100">
                    <button
                      type="button"
                      onClick={() => setIsRewardPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Save
                    </button>
                  </div>
                </form>
              )}

              {/* View Reward Details */}
              {rewardPanelType === "view" && selectedReward && (
                <div className="space-y-4">
                  {/* Top user profile header card */}
                  <div className="p-4 rounded-2xl border border-gray-150 bg-white flex items-center justify-between gap-4 shadow-sm">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 rounded-full bg-[#FBD037]/20 border border-[#FBD037]/45 flex items-center justify-center text-base font-bold uppercase text-amber-800 shadow-sm">
                        {selectedReward.name.charAt(0)}
                      </div>
                      <div className="text-left">
                        <div className="font-bold text-sm text-[#212121]">{selectedReward.name}</div>
                        <div className="text-[11px] text-gray-400 font-semibold">{selectedReward.dept}</div>
                        <div className="text-[11px] text-gray-400 font-semibold mt-0.5">{selectedReward.designation}</div>
                      </div>
                    </div>
                    <div>
                      <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full border shadow-sm ${
                        selectedReward.status === "Approved"
                          ? "text-emerald-700 bg-emerald-50 border-emerald-200/50"
                          : selectedReward.status === "Rejected"
                          ? "text-rose-700 bg-rose-50 border-rose-200/50"
                          : "text-amber-700 bg-amber-50 border-amber-200/50"
                      }`}>
                        ● {selectedReward.status}
                      </span>
                    </div>
                  </div>

                  {/* Detail Grid */}
                  <div className="grid grid-cols-2 gap-4 text-xs font-semibold">
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Employee ID</span>
                      <span className="text-[#212121]">{selectedReward.employeeIdStr}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Employee Name</span>
                      <span className="text-[#212121]">{selectedReward.name}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Department</span>
                      <span className="text-[#212121]">{selectedReward.dept}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Designation</span>
                      <span className="text-[#212121]">{selectedReward.designation}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Reward Type</span>
                      <span className="text-[#212121]">{selectedReward.rewardType}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Reward Date</span>
                      <span className="text-[#212121]">{selectedReward.rewardDate}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Created Date</span>
                      <span className="text-[#212121]">{selectedReward.createdDate}</span>
                    </div>
                    <div className="p-3 bg-white border border-gray-100 rounded-2xl shadow-sm">
                      <span className="text-[10px] uppercase font-bold text-gray-400 block mb-0.5">Link Appreciation</span>
                      <span className="text-[#212121]">{selectedReward.linkAppreciation ? "Yes" : "No"}</span>
                    </div>
                  </div>

                  {/* Remarks Description Card */}
                  <div className="p-4 rounded-2xl border border-gray-150 bg-white space-y-1 shadow-sm">
                    <span className="text-[10px] uppercase font-bold text-gray-400 block">Reward Item Description</span>
                    <p className="text-xs font-semibold text-slate-800 leading-relaxed whitespace-pre-wrap">{selectedReward.rewardRemark || "No description provided."}</p>
                  </div>

                  {/* Processor / Approver Information */}
                  <div className="p-4 rounded-2xl border border-gray-150 bg-white flex items-center justify-between gap-4 shadow-sm">
                    <div className="flex items-center gap-2">
                      <div className="w-9 h-9 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center text-xs font-bold uppercase text-gray-700 shadow-sm">
                        {selectedReward.rewardedBy.charAt(0)}
                      </div>
                      <div className="text-left">
                        <span className="text-[10px] uppercase font-bold text-gray-400 block">Rewarded By</span>
                        <span className="text-xs font-bold text-[#212121]">{selectedReward.rewardedBy}</span>
                        <span className="text-[10px] text-gray-400 block font-semibold">{selectedReward.rewardedByDept}</span>
                      </div>
                    </div>
                    {selectedReward.status === "Approved" && (
                      <div className="flex items-center gap-2">
                        <div className="w-9 h-9 rounded-full bg-blue-50 flex items-center justify-center text-xs font-bold uppercase text-blue-700 border border-blue-100 shadow-sm">
                          {selectedReward.approvedBy.charAt(0)}
                        </div>
                        <div className="text-left">
                          <span className="text-[10px] uppercase font-bold text-gray-400 block">Approved By</span>
                          <span className="text-xs font-bold text-[#212121]">{selectedReward.approvedBy}</span>
                          <span className="text-[10px] text-gray-400 block font-semibold">{selectedReward.approvedByDept}</span>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-end gap-2 border-t border-gray-100">
                    <button
                      onClick={() => setIsRewardPanelOpen(false)}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-50 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Close
                    </button>
                  </div>
                </div>
              )}

              {/* Filter Rewards Sidebar Panel */}
              {rewardPanelType === "filter" && (
                <div className="space-y-4">
                  <SectionBlock title="Filter Criteria" icon={IconFilter}>
                    <div className="space-y-3.5">
                      <div className="grid grid-cols-2 gap-4">
                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Start Date</label>
                          <input
                            type="date"
                            value={filterRewardStartDate}
                            onChange={(e) => setFilterRewardStartDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>

                        <div className="space-y-1">
                          <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">End Date</label>
                          <input
                            type="date"
                            value={filterRewardEndDate}
                            onChange={(e) => setFilterRewardEndDate(e.target.value)}
                            className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold"
                          />
                        </div>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Employee</label>
                        <select
                          value={filterRewardEmployeeId}
                          onChange={(e) => setFilterRewardEmployeeId(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Employee</option>
                          {employees.map((emp) => (
                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Rewarded By</label>
                        <select
                          value={filterRewardRewardedById}
                          onChange={(e) => setFilterRewardRewardedById(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Rewarded By</option>
                          {Array.from(new Set(rewardList.map(e => e.rewardedBy))).map((by) => (
                            <option key={by} value={by}>{by}</option>
                          ))}
                        </select>
                      </div>

                      <div className="space-y-1">
                        <label className="text-[#1E293B] text-xs font-semibold flex items-center gap-0.5 mb-1 block">Reward Type</label>
                        <select
                          value={filterRewardType}
                          onChange={(e) => setFilterRewardType(e.target.value)}
                          className="w-full rounded-xl py-[10px] px-4 outline-none text-xs bg-white border border-[#D8D8D8] text-[#1E1E1E] focus:border-[#FBD037] focus:ring-2 focus:ring-[#FBD037]/20 transition-all font-semibold cursor-pointer"
                        >
                          <option value="">Select Reward Type</option>
                          <option value="NonMonetary">NonMonetary</option>
                          <option value="Monetary">Monetary</option>
                        </select>
                      </div>
                    </div>
                  </SectionBlock>

                  {/* Actions buttons */}
                  <div className="pt-2 flex justify-between gap-3 border-t border-gray-100">
                    <button
                      onClick={() => {
                        setFilterRewardStartDate("");
                        setFilterRewardEndDate("");
                        setFilterRewardEmployeeId("");
                        setFilterRewardRewardedById("");
                        setFilterRewardType("");
                        toast.success("Filters cleared");
                      }}
                      className="px-5 py-2 border border-gray-200 rounded-xl text-xs font-semibold hover:bg-gray-55 text-gray-700 transition cursor-pointer bg-white"
                    >
                      Clear All
                    </button>
                    <button
                      onClick={() => setIsRewardPanelOpen(false)}
                      className="px-6 py-2 bg-[#FBD037] text-[#212121] rounded-xl text-xs font-bold hover:bg-[#e2bd30] transition cursor-pointer border-none shadow-sm"
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              )}

            </div>
          </div>
        )}

      </div>
    </div>
  );
}
